module.exports = __webpack_public_path__ + "img/sc-3&4p-2023.cfe3395f.jpg";